const OUTLINK_INFO = 'index/OUTLINK_INFO' as const;
const SET_OUTLINK_INFO = 'index/SET_OUTLINK_INFO' as const;
export const getOutLinkInfo = () => ({
  type: OUTLINK_INFO,
});

export const setOutLinkInfo = (state: OutLinkState) => ({
  type: SET_OUTLINK_INFO,
  payload: state,
});

type OutLinkAction = ReturnType<typeof getOutLinkInfo> | ReturnType<typeof setOutLinkInfo>;

export type OutLinkState = {
  path: string;
  toAddr: string | `0x${string}`;
  amount: string;
  symbol: string;
  chain: string;
};
const initialState: OutLinkState = {
  path: '',
  toAddr: '',
  amount: '',
  symbol: '',
  chain: '',
};

function outLink(state: OutLinkState = initialState, action: OutLinkAction): any {
  switch (action.type) {
    case OUTLINK_INFO:
      return { ...state };
    case SET_OUTLINK_INFO:
      return { ...action.payload };
    default:
      return state;
  }
}

export default outLink;
